<template>
  <main>
    <Hero/>
    <div v-scroll-spy="{offset: 64}">
      <Billboard/>
      <Releases/>
      <Snacks/>
      <Promotions/>
      <Contact/>
    </div>
    <Modal
      v-show="modalTrailerState"
      @close="closeTrailerModal">
      <div class="loader"/>
      <div
        class="trailer"
        v-html="modalTrailerIframe"/>
    </Modal>
    <Modal
      v-show="modalMovieState"
      ref="modalMovie"
      @close="closeMovieModal">
      <ModalMovie/>
    </Modal>
  </main>
</template>

<script>
import Hero from '@/components/Hero.vue';
import Billboard from '@/components/Billboard.vue';
import Releases from '@/components/Releases.vue';
import Snacks from '@/components/Snacks.vue';
import Promotions from '@/components/Promotions.vue';
import Contact from '@/components/Contact.vue';
import Modal from '@/components/Modal.vue';
import ModalMovie from '@/components/ModalMovie.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Home',
  components: {
    Hero,
    Billboard,
    Releases,
    Snacks,
    Promotions,
    Contact,
    Modal,
    ModalMovie,
  },
  computed: {
    ...mapGetters([
      'modalTrailerState',
      'modalTrailerIframe',
      'modalMovieState',
    ]),
  },
  methods: {
    ...mapActions([
      'closeTrailerModal',
      'closeMovieModal',
    ]),
  },
};
</script>

